import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // =========================== 公告模块 start ====================
  // 获取列表
  async getNoticeList(params) {
    return request({ method: POST, url: `/admin/notice/list`, params })
  },
  // 获取公告信息
  async getNoticeType(params) {
    return request({ method: GET, url: `/admin/notice/${params.type}` })
  },
  // 新增公告信息
  async getAddNotice(params) {
    return request({ method: POST, url: `/admin/notice/add`, params })
  },
  // 获取公告信息详情
  async getNoticeDetail(params) {
    return request({ method: GET, url: `/admin/notice/detail/${params.id}` })
  },
  // 获取草稿公告列表
  async getDraftList(params) {
    return request({ method: POST, url: `/admin/notice/draft/list`, params })
  },
  // 编辑公告
  async editNotice(params) {
    return request({ method: POST, url: `/admin/notice/edit`, params })
  },
  // 上传
  async upload(params) {
    return request({ method: POST, url: `/admin/file/upload`, params })
  },
  // 删除公告信息
  async deleteNotice(params) {
    return request({ method: POST, url: `/admin/notice/delete`, params })
  },
}
